import { useMutation } from "@tanstack/react-query";
import {
  type CreatePartyCommandResult,
  type CreatePartyDto,
  postParties,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (publicID: string) => void;
  onError?: () => void;
};

export const useCreatePartyMutation = ({ onSuccess, onError }: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails((data: CreatePartyDto) =>
      postParties(data),
    ),
    onSuccess: (data: CreatePartyCommandResult) => {
      onSuccess?.(data.publicID);
    },
    onError,
  });
